import React from "react";
import "../App.css";
import { LoadingPlaceholder } from "genesys-react-components";

export function Loading({ loadingText }) {

  return (
    <LoadingPlaceholder text={loadingText}/>
  );
}
